import {createAction} from '@ngrx/store';

export const toggleGridView = createAction('[Layout] Toggle Grid View');
